import React from 'react';
export function Footer() {
  return <footer className="bg-black py-8 border-t border-dark-border text-center px-4" data-id="element-20">
      <div className="max-w-4xl mx-auto" data-id="element-21">
        <p className="text-gray-500 text-sm font-medium mb-2" data-id="element-22">
          © 2026 Entrena en Casa™ — Todo Argentina
        </p>
        <p className="text-gray-600 text-xs max-w-2xl mx-auto" data-id="element-23">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc. Los resultados
          pueden variar de persona a persona.
        </p>
      </div>
    </footer>;
}